
import ReactPlayer from 'react-player'
import {isMobile} from 'react-device-detect'

import { Nav, Navbar, Container, Row, Col } from 'react-bootstrap';

import logo from './img/logo.png'
import title from './img/title.png'
import motiva from './img/motiva.png'
import mandarina from './img/mandarina.png'
import mole from './img/mole.png'
import mg from './img/mg.png'
import footerImg from './img/footer-logo.png'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div align="center"> <img src={logo} className="logo" /> </div>
          </Col>
        </Row>
      </Container>

      <div>
        <ReactPlayer className="player-v" url='mgp.mp4' playing={ true } loop={ true } volume={ 0 } muted={ true } controls={ isMobile ? true : false } />
      </div>

      <div className='us-section'>
        <Container>
          <Row className='align-items-center'>
            <Col md={ 5 }>
              <img src={ title } className='title-cls' />
            </Col>

            <Col md={ 7 } className='col-line'>
              <div className='us-desc'>
                <span className='us-desc-bold'>MG Marketing Group</span> es un hub empresarial con más de 16 años de experiencia, conformado por <span className='us-desc-bold'>cuatro agencias especializadas</span> que trabajan en sinergia para ofrecer soluciones integrales, creativas e innovadoras.
              </div>

              <div className='us-desc'>
                Nos especializamos en construir ideas que conectan, estrategias que funcionan y resultados que marcan diferencia. Nuestro crecimiento se ha basado en <span className='us-desc-bold'>el poder del trabajo en equipo,</span> la <span className='us-desc-bold'>diversidad de talentos</span> y la capacidad de adaptarnos a los cambios del mercado con visión y estrategia.
              </div>

              <div className='us-desc'>
                En MG, cada proyecto es una oportunidad para sumar experiencia, generar impacto y llevar la creatividad a otro nivel. Partimos de una visión estratégica y ejecutamos con precisión cada etapa del proceso, desde la idea hasta su implementación, está pensada al detalle para que nuestros clientes no solo comuniquen, sino conquisten con propósito y resultados.
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='us-section'>
        <Container>
          <Row className='align-items-center brand-row'>
            <Col md={ 12 } className='brand-img-div'>
              <a href='https://mgpublicidad.mx/'>
                <div className="centered">
                  <div className='image-title'> 
                    <span className='us-desc-bold'>En MG Publicidad transformamos  marcas en historias memorables a través de experiencias únicas y estrategias integrales.</span> Somos una agencia 360° con 6 unidades de negocio especializadas, lo que nos permite ofrecer soluciones completas y adaptadas a cada necesidad. Nuestro liderazgo se basa en la innovación, creatividad y un enfoque claro hacia resultados. 
                    <div className='image-subtitle'>Tu éxito no solo es nuestra prioridad, es nuestra especialidad.</div>
                    <br/>
                    <div align="center">
                      <div className='text-link'>
                        Ir al Sitio
                      </div>
                    </div>
                  </div>
                </div>
                <div className='item item-hide'>
                  <img src={ mg } className='brand-img' style={{ visibility: 'hidden' }} />
                </div>

                <div className='item'>
                  <img src={ mg } className='brand-img' />
                </div>
              </a>
            </Col>
          </Row>

          <Row className='align-items-center brand-row'>
            <Col md={ 12 } className='brand-img-div'>
              <a href='https://mandarinapromocionales.mx/'>
                <div className="centered">
                  <div className='image-title'> 
                    Somos una marca especializada en la <span className='us-desc-bold'>personalización de artículos promocionales</span> de cualquier tipo, desde los más accesibles, hasta los de categoría premium.
                    <div>Cada producto de nuestro catálogo ha sido establecido meticulosamente para garantizar que reflejen la <span className='image-subtitle'>esencia, la identidad y los valores de tu marca</span>, asegurando una conexión duradera y significativa con tu público objetivo.</div>
                    <br/>
                    <div align="center">
                      <div className='text-link'>
                        Ir al Sitio
                      </div>
                    </div>
                  </div>
                </div>
                <div className='item item-hide'>
                  <img src={ mandarina } className='brand-img' style={{ visibility: 'hidden' }} />
                </div>

                <div className='item'>
                  <img src={ mandarina } className='brand-img' />
                </div>
              </a>
            </Col>
          </Row>

          <Row className='align-items-center brand-row'>
            <Col md={ 12 } className='brand-img-div'>
              <a href='https://molecreativo.mx/'>
                <div className="centered">
                  <div className='image-title'> 
                    <div>En <span className='us-desc-bold'>Mole Creativo</span> potenciamos las ideas con una <span className='us-desc-bold'>mezcla explosiva de creatividad e innovación,</span> dando vida a conceptos que trascienden lo convencional. <span className='us-desc-bold'>Somos una agencia creativa digital</span> que combina ingenio, pasión y estrategia para conectar marcas con personas de manera auténtica. Creemos en el poder de las historias bien contadas y en la magia de <span className='image-subtitle'>la creatividad sin límites</span>. Aquí, cada proyecto es una obra maestra en proceso.</div>
                    <br/>
                    <div align="center">
                      <div className='text-link'>
                        Ir al Sitio
                      </div>
                    </div>
                  </div>
                </div>
                <div className='item item-hide'>
                  <img src={ mole } className='brand-img' style={{ visibility: 'hidden' }} />
                </div>

                <div className='item'>
                  <img src={ mole } className='brand-img' />
                </div>
              </a>
            </Col>
          </Row>

          <Row className='align-items-center brand-row'>
            <Col md={ 12 } className='brand-img-div'>
              <a href='https://motivastudio.com.mx/'>
                <div className="centered">
                  <div className='image-title'> 
                    <div>En <span className='us-desc-bold'>Motiva Studio</span>, somos un despacho de arquitectura especializado en el diseño y ejecución de proyectos comerciales y residenciales. 
                    <span className='us-desc-bold'>Nos impulsa la pasión</span> por crear espacios funcionales, estéticos y únicos, que respondan con precisión a las necesidades de cada cliente. Fusionamos creatividad, técnica e innovación para lograr <span className='image-subtitle'>resultados excepcionales que trascienden</span> lo convencional.</div>
                    <br/>
                    <div align="center">
                      <div className='text-link'>
                        Ir al Sitio
                      </div>
                    </div>
                  </div>
                </div>
                <div className='item item-hide'>
                  <img src={ motiva } className='brand-img' style={{ visibility: 'hidden' }} />
                </div>

                <div className='item'>
                  <img src={ motiva } className='brand-img' />
                </div>
              </a>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='us-section' style={{ backgroundColor: '#021E33' }}>
        <Container>
          <Row>
            <Col md={ 6 }>
              <div className='footer-left'>
                <a href='mailto:contacto@mgpublicidad.mx'><div className='footer-text'>contacto@mgpublicidad.mx</div></a>
                <a href='https://mgpublicidad.mx/'><div className='footer-text'>mgpublicidad.mx</div></a>
              </div>
            </Col>
            <Col md={ 6 }>
              <div className='footer-right'>
                <img src={ footerImg } className='footer-img' />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default App;
